import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { Grid } from "@mui/material";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { Dispatch } from "react";

export interface CovestroColorCodeFilterProps {
  value: Array<AutocompleteData> | undefined;
  onChange?: Dispatch<Array<AutocompleteData>>;
  t: (key: string) => string;
}

export const CovestroColorCodeFilter = ({
  value = [],
  onChange,
  t,
}: CovestroColorCodeFilterProps) => {
  return (
    <Grid size={{ xs: 12, md: 6, xl: 3 }}>
      <ColorSearchAutocomplete
        label={t("filter_color_code_covestro")}
        type="finalColorCode"
        value={value}
        onChange={onChange}
      />
    </Grid>
  );
};
